<template>
  <div class="app-root" data-theme="dark">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// App root — layout is handled by AppLayout.vue via the router
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body,
#app,
.app-root {
  height: 100%;
  width: 100%;
  background-color: #0d1117;
  color: #e6edf3;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

:root {
  color-scheme: dark;
}

/* Element Plus dark mode overrides */
.el-card {
  --el-card-bg-color: #161b22;
  --el-card-border-color: #30363d;
}

.el-table {
  --el-table-bg-color: #161b22;
  --el-table-tr-bg-color: #161b22;
  --el-table-header-bg-color: #0d1117;
  --el-table-border-color: #30363d;
  --el-table-text-color: #e6edf3;
  --el-table-header-text-color: #8b949e;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #0d1117;
}
::-webkit-scrollbar-thumb {
  background: #30363d;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #484f58;
}
</style>
